import React, { Fragment, useState } from "react";
import { FiPaperclip, FiSend } from "react-icons/fi";
import useChatStore from "../../store/useChatStore";
import { API_URL } from "../../api-services/Environment";

const ChatFooter = (props) => {
  const { currentScreen, setCurrentScreen } = useChatStore();
  const { handleChatMessage, message, setMessage } = props;

  const handleSendMessage = () => {
    // if (currentScreen !== 'chat') {
    //   setCurrentScreen('chat');
    // }

    if (message.trim() !== "") {
      if (handleChatMessage) {
        handleChatMessage(message);
      } else {
        setMessage("");
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
    <div className="chat-footer">
      {currentScreen !== "order-details" ? (
        <Fragment>
          <input
            type="text"
            placeholder="Message Support Bot"
            className="chat-input"
            onChange={(e) => setMessage(e.target.value)}
            value={message}
            onKeyDown={handleKeyDown}
          />
          {/* <button className="attach-btn" aria-label="Attach a file">
              <FiPaperclip style={{ fontSize: '14px' }}/>
            </button> */}
          {props.loading ? (
            <img
              src={`${API_URL}common/gif/loader.gif.gif`}
              alt="loader"
              style={{ position: "absolute", right: 18, width: 35, height: 35 }}
            />
          ) : (
            <button
              className="send-btn"
              aria-label="Send message"
              onClick={handleSendMessage}
            >
              <FiSend style={{ fontSize: "14px" }} />
            </button>
          )}
        </Fragment>
      ) : (
        <div className="need-more-help">
          <span>Need more help?</span>
          <button
            className="chat-button"
            onClick={() => setCurrentScreen("chat")}
          >
            Chat with us
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatFooter;
